// extracted by mini-css-extract-plugin
export default {"profile__page":"UserProfilePage_profile__page__HfZXk"};